import { connect } from 'react-redux';

import OutTaskCategory from '../../components/sider/outTaskCategory';

export default connect()(OutTaskCategory);



// WEBPACK FOOTER //
// ./containers/sider/outTaskCategory.js